import { render } from "./ModalAutoSave.vue?vue&type=template&id=b646d61a&scoped=true"
import script from "./ModalAutoSave.vue?vue&type=script&lang=js"
export * from "./ModalAutoSave.vue?vue&type=script&lang=js"

import "./ModalAutoSave.vue?vue&type=style&index=0&id=b646d61a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b646d61a"]])

export default __exports__